// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 768px) {
  main {
    background-image: url("/assets/images/circles-corner.svg");
    background-repeat: no-repeat;
    background-position: top right;
    background-size: 35%;
    background-position-y: 450px;
  }
}

.heading {
  color: #191919;
  text-transform: uppercase;
  font-size: 15px;
  position: relative;
  margin-left: 50px;
  margin-bottom: 15px;
  line-height: 1;
  letter-spacing: 1px;
}
@media (min-width: 768px) {
  .heading {
    margin-left: 70px;
  }
}
.heading:before {
  border-top: 1px solid #191919;
  content: "";
  position: absolute;
  left: -50px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
}
@media (min-width: 768px) {
  .heading:before {
    left: -70px;
    width: 50px;
  }
}

.title {
  font-size: 45px;
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 1;
}
@media (min-width: 1024px) {
  .title {
    font-size: 60px;
  }
}

.logo {
  height: 100%;
}

.message {
  margin-top: 15px;
  margin-bottom: 15px;
  white-space: pre-wrap;
  font-weight: bold;
}

.custom-container {
  box-sizing: border-box;
}
.custom-container.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.custom-container.blue {
  --tw-bg-opacity: 1;
  background-color: rgb(26 39 65 / var(--tw-bg-opacity));
}
@media screen {
  .custom-container {
    padding: 15px;
  }
}
.custom-container.flush {
  padding: 0;
}

.contact-agent {
  background-color: #fff;
  margin-bottom: 15px;
  font-size: 16px;
}
@media print {
  .contact-agent {
    padding-bottom: 10px;
    border-bottom: 4px solid #ecc23c;
  }
}
.contact-agent h2 {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 18px;
}
.contact-agent div a,
.contact-agent div div {
  margin: 0;
  width: 100%;
  overflow: hidden;
}
.contact-agent img {
  max-height: 26px;
  max-width: 26px;
  margin-right: 15px;
  display: inline-block;
}
.contact-agent a:hover {
  text-decoration: underline;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
